import Storage from "@/utils/Storage";
import { addContentListApi, delContentListApi } from "@/api/shop";


export default {

  CLEAR_STATE(state, payload) {
    state.token = ''
    Storage.removeItem("TOKEN");
    state.userInfo = {}
    Storage.removeItem("USERINFO");
    state.uid = ''
    Storage.removeItem("UID");
    state.region = {}
    Storage.removeItem("REGION");
    state.company = {}
    Storage.removeItem("COMPANY");
    state.selectactivity = {}
    Storage.removeItem("SELECTACTIVITY")

    state.cardInfo = {}
    state.addCurrentProduct = {
      video: "",
      cate_id: "",
      title: "",
      describe: "",
      third_link: "",
      shipping_template_id: null,
      images: [],
      info: [],
      is_live: false,
      sku: [],
      certificates: [],
      source: '',
      send_type: 0,
      is_cross_border: true, // true 跨境销售 false 非跨境销售
      flags: [ ],
    }

    state.selectcourse = {}
    state.merchantIndex = {}
    state.myBankList = []
    state.email_list = []

    state.source_list = []
    Storage.removeItem("SOURCELIST")
    state.replay_list = []
    Storage.removeItem("REPLAYLIST")
    state.chat_unread_num = 0
    Storage.removeItem("chat_unread_num")

    state.show_prompt_sound = true
    state.conversation = {}

    state.AccessKey = {}
    Storage.removeItem("AccessKey")
  },

  SET_TOKEN(state, payload) {
    state.token = payload;
    Storage.setItem("TOKEN", payload);
  },
  SET_ACCESSKEY(state, payload) {
    state.AccessKey = payload;
    Storage.setItem("AccessKey", payload);
  },

  SET_USER_INFO(state, payload) {
    state.userInfo = payload;
    Storage.setItem("USERINFO", payload);
  },

  SET_UID(state, payload) {
    state.uid = payload;
    Storage.setItem("UID", payload);
  },
  SET_REGION(state, payload) {
    state.region = payload;
  },
  SET_COMPANY(state, payload) {
    state.company = payload;
    Storage.setItem("COMPANY", payload);
  },
  SET_CARDINFO(state, payload) {
    state.cardInfo = payload;
  },
  SET_SELECTACTIVITY(state, payload) {
    state.selectactivity = payload;
    Storage.setItem("SELECTACTIVITY", payload);
  },
  SET_SELECTCOURSE(state, payload) {
    state.selectcourse = payload;
  },
  SET_ADDCURPRODUCT(state, payload) {
    state.addCurrentProduct = payload;
  },
  SET_MERCHANTINDEX(state, payload) {
    state.merchantIndex.authorization_template = payload.authorization_template
    state.merchantIndex.copyright = payload.copyright
    state.merchantIndex.distribute = payload.distribute
    state.merchantIndex.merInfo = payload.merInfo
    state.merchantIndex.result = payload.result
  },
  SET_MERCHANTCODE(state, payload) {
    state.userInfo.shop_status = payload || 0;
  },
  GET_MERCHANTHELPER(state, payload) {
    state.merchantIndex.helper = payload
  },
  SET_MYBANKLIST(state, payload) {
    state.myBankList = payload
  },
  SET_CURRENTROUTER(state, payload) {
    state.current_router = payload;
  },
  GET_EMAILLIST(state, payload) {
    state.email_list = payload
  },
  SER_EMAILLIST(state, payload) {
    addContentListApi({
      content: payload
    })
  },
  DEL_EMAIL(state, payload) {
    delContentListApi({
      id: state.email_list[payload].id
    }).then(res => {
      state.email_list.splice(payload, 1)
    })
  },
  SER_SOURCELIST(state, payload) {
    if (state.source_list.includes(payload)) return
    state.source_list.unshift(payload)
    Storage.setItem("SOURCELIST", state.source_list)
  },
  SET_REPLAYLIST(state, payload) {
    if (state.replay_list.includes(payload) || !payload) return
    state.replay_list.unshift(payload)
    Storage.setItem("REPLAYLIST", state.replay_list)
  },
  DEL_SOURCE(state, payload) {
    state.source_list.splice(payload, 1)
    Storage.setItem("SOURCELIST", state.source_list)
  },
  SET_PATH(state, payload) {
    state.path = payload
  },
  SET_CHAT_UNREAD_NUM(state, val) {
    val = parseInt(val) <= 0 ? 0 : val;
    // console.log("消息数量：", val)
    state.chat_unread_num = val;
    Storage.setItem("chat_unread_num", val);
  },
  SET_SERVICE_UNREAD_NUM(state, val) {
    val = parseInt(val) <= 0 ? 0 : val;
    state.service_unread_num = val;
    Storage.setItem("service_unread_num", val);
  },

  DIALOGUE_LISTEN(state, val) {
    console.log(val)
  },
  SET_PEOMPT_SOUND(state, val) {
    state.show_prompt_sound = val
  },
  SET_CONVERSATION(state, val) {
    state.conversation = val
  },
  SET_PREV_DELIVERY(state, val) {
    state.prev_delivery = val;
    Storage.setItem("prev_delivery", val);
  }
};
